<div class="readonly-field">
  <label class="readonly-label">{{ props.label }}</label>
  @if (photoDataUrls().length > 0) {
  <div class="photo-previews-container">
    @for (photoUrl of photoDataUrls(); track $index) {
    <div class="photo-preview">
      <img [src]="photoUrl" [alt]="props.label + ' photo ' + ($index + 1)" class="photo-preview-img"
        [attr.data-testid]="'readonly-photo-preview-' + $index" />
      <div class="photo-preview-controls">
        <app-button variant="outlined" size="sm" (click)="downloadPhoto(photoUrl, $index)"
          [attr.data-testid]="'readonly-download-photo-btn-' + $index">
          <app-icon [size]="16" name="download" />
          {{ 'submission.view.downloadPhoto' | translate }}
        </app-button>
      </div>
    </div>
    }
  </div>
  } @else {
  <span class="readonly-value readonly-empty">{{ 'submission.view.noValue' | translate }}</span>
  }
</div>